module.exports = __webpack_public_path__ + "img/show_tc_text_4.f9fe6632.png";